import { DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCustomerOrderCountReport extends Layout {
    etCustomers: ExcludableTextbox;
    sourceCustomerOrderCount: DataSource;
    switchGroupBy: Switch;
    textboxDateRange: Textbox;
    textboxDateType: Textbox;
    textboxInterval: Textbox;
}
